import axios from 'axios'
import { Post } from '../entities/Post'
import { Category } from '../entities/Category'
import { postTemplate } from '../template/PostTemplate'
import { asyncLoader } from '../core/AsyncLoader'

class WebsiteService {
	baseUrl
	counter = 3
	_categories = {}

	get http () {
		return axios.create({
			baseURL: this.baseUrl,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		})
	}

	setBaseUrl (baseUrl) {
		this.baseUrl = baseUrl
		return this
	}

	setCounter (counter) {
		this.counter = counter
		return this
	}

	async getPosts ({offset}) {
		try {
			const {data} = await this.http.post('', this._getParams({
				offset
			}))
			asyncLoader.setFinished(data.finished)
			return data.posts.map(this._createPost.bind(this))
		} catch (err) {
			console.error(err)
		}
	}

	async getPostsForCategory ({offset, activeCategoryId}) {
		try {
			const {data} = await this.http.post('', this._getParams({
				offset,
				activeCategoryId
			}))
			asyncLoader.setFinished(data.finished)
			return data.posts.map(this._createPost.bind(this))
		} catch (err) {
			console.error(err)
		}
	}

	_getParams ({offset, activeCategoryId}) {
		const params = new URLSearchParams()
		params.append('option', 'com_ajax')
		params.append('plugin', 'GetContent')
		params.append('format', 'json')
		params.append('counter', this.counter)
		params.append('offset', offset)
		if (activeCategoryId) params.append('id', activeCategoryId)
		return params
	}

	_createPost (element) {
		const post = new Post()

		post.title = element.title
		post.description = element.description
		post.alias = element.alias
		post.featured = element.featured
		post.imageLink = element.imageLink
		post.link = element.link
		post.created = element.created
		post.published = element.published
		post.category = this._getCategory({
			id: element.category_id,
			title: element.category_title,
			route: element.category_route
		})
		post.template = postTemplate
		post.category.addPost(post)
		return post
	}

	_getCategory (category) {
		if (!this._categories[category.id]) this._categories[category.id] = new Category(category)
		return this._categories[category.id]
	}
}

const websiteService = new WebsiteService()
export { WebsiteService, websiteService }



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_async_posts_loader/service/WebsiteService.js